import { AuthStorage } from "utils/auth-storage";
import {
  Button,
  Tooltip,
  Select,
  Input,
  Table,
  Modal,
  Switch,
  Checkbox,
} from "antd";
import React, { useEffect, useState, useContext, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import LoadingComponent from "components/loading-component";
import Text from "components/text";
import { CompanyAdminServices } from "apis/Services/CompanyAdminService";
import styles from "./company-dashboard.module.css";
import { DndContext } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { HolderOutlined } from "@ant-design/icons";
import CreateColumn from "./create-column";
import { ProjectServices } from "apis/Services/ProjectService";
import { toast } from "react-hot-toast";
import smallLogo from "assets/images/small-logo.png";

const RowContext = React.createContext({});

const DragHandle = () => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  return (
    <Button
      type="text"
      size="small"
      icon={<HolderOutlined />}
      style={{ cursor: "move" }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

const SortableRow = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props["data-row-key"],
  });

  const style = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: "relative", zIndex: 9999 } : {}),
  };

  const contextValue = useMemo(
    () => ({ setActivatorNodeRef, listeners }),
    [setActivatorNodeRef, listeners]
  );

  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  );
};

export default function CreateView({
  selectedViewName,
  projectsDropDown,
  viewName,
  setViewName,
  viewDescription,
  setViewDescription,
  setCreateFlag,
  readCompanySchedule,
  editFlag,
  setEditFlag,
  procoreColumnsInfo,
  scheduleColumnsInfo,
  undeletableColumns,
  projectsInfoArray,
  updateUndeleteableColumns,
}) {
  let code = AuthStorage.getItem("token");
  let loginEmail = AuthStorage.getItem("email");
  let Auth = {
    code,
    loginEmail,
  };

  const { company_id } = useParams();

  const [isLoading, setIsLoading] = useState();
  const [dataSample, setDataSample] = useState([]);
  const [columnsInfo, setColumnsInfo] = useState(selectedViewName.columnsInfo);
  const [originalColumnsInfo, setOriginalColumnsInfo] = useState(
    selectedViewName.columnsInfo
  );
  const [initialSetupDone, setInitialSetupDone] = useState(false);
  const [assignedProjects, setAssignedProjects] = useState([]);
  const [viewsProjects, setViewsProjects] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [createNewColumnModalOpen, setCreateNewColumnModalOpen] =
    useState(false);
  const [changesMadeFlag, setChangesMadeFlag] = useState(false);
  const [oldViewName, setOldViewName] = useState("");
  const [disableAssignProjectList, setDisableAssignProjectList] =
    useState(false);

  const [showAllColumns, setShowAllColumns] = useState(true);

  const [createColumnType, setCreateColumnType] = useState("");
  const [createColumnFlag, setCreateColumnFlag] = useState(false);
  const [remainingColumns, setRemainingColumns] = useState();
  const [firstUnusedColumn, setFirstUnusedColumn] = useState("");

  const [columnName, setColumnName] = useState("");

  const [columnDescription, setColumnDescription] = useState("");

  const [columnType, setColumnType] = useState("");

  const [columnkey, setColumnkey] = useState("");

  const [source, setSource] = useState("");

  const [columnFormula, setColumnFormula] = useState("");

  const [formulaRows, setFormulaRows] = useState([]);
  const [originalFormulaRows, setOriginalFormulaRows] = useState([]);

  const [columnsChange, setColumnsChange] = useState(false); // used in the useEffect to save changes automatically after updating columns

  const [saveConfigurationFlag, setSaveConfigurationFlag] = useState(false); // when columns sort or visibility changes
  const [closeConfigurationFlag, setCloseConfigurationFlag] = useState(false); // when columns are created or updated

  const [shouldRecalculate, setShouldRecalculate] = useState(false); // if true then call recalculate function after saving

  let viewSaveFlag = false;

  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      viewName: viewName,
      viewDescription: viewDescription,
      assignedProjects:
        selectedViewName?.viewProjects?.map(
          (project) => project.split("-")[0]
        ) || assignedProjects,
    },
  });

  const getSampleProcurementLogsViews = (value) => {
    setIsLoading(true);
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      loginEmail,
      code,
      projectID: value,
      viewName: selectedViewName.viewName,
    };
    CompanyAdminServices.getSampleProcurementLogsViews(data)
      .then((res) => {
        setDataSample(res.dataSample);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const webhooksUpdate = (projectsInfoArray, company_id, code, loginEmail) => {
    // Create an array of promises for each project
    const exportwebhooksPromises = projectsInfoArray.map((project) => {
      const updateBackEndData = {
        company: company_id,
        project: project.projectID,
        code,
        loginEmail,
        approvalTime: project.approvalTime,
        reviewTime: project.reviewTime,
      };

      // Return the promise from the getExportData call
      return ProjectServices.webhooks(updateBackEndData);
    });

    // Wait for all promises to resolve
    return Promise.all(exportwebhooksPromises);
  };

  const updateProjectsData = (
    projectsInfoArray,
    company_id,
    code,
    loginEmail
  ) => {
    // Create an array of promises for each project
    const exportPromises = projectsInfoArray.map((project) => {
      const updateBackEndData = {
        company: company_id,
        project: project.projectID,
        code,
        loginEmail,
        approvalTime: project.approvalTime,
        reviewTime: project.reviewTime,
      };

      // Return the promise from the getExportData call
      return ProjectServices.getExportData(updateBackEndData);
    });

    // Wait for all promises to resolve
    return Promise.all(exportPromises);
  };

  const createProcurementLogsViews = async () => {
    const toastId = toast.loading("Saving view");
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      loginEmail,
      code,
      viewName: viewName,
      viewDescription: viewDescription,
      columnsInfo: [columnsInfo],
      assignedProjects: assignedProjects,
    };

    try {
      const res = await CompanyAdminServices.createProcurementLogsViews(data);

      if (viewSaveFlag) {
        setCreateFlag(false);
        setViewName("");
        readCompanySchedule();
      }

      viewSaveFlag = false;
      toast.success("View saved successfully", { id: toastId });

      if (!columnsChange && shouldRecalculate) {
        setShouldRecalculate(false);
        // First, call webhooksUpdate and wait for it to finish
        await webhooksUpdate(projectsInfoArray, company_id, code, loginEmail);
        // Then, call updateProjectsData
        await updateProjectsData(
          projectsInfoArray,
          company_id,
          code,
          loginEmail
        );
      }
    } catch (err) {
      toast.error("Something went wrong, please try again.", { id: toastId });
      console.log(err);
    }
  };

  const updateProcurementLogsViews = async () => {
    const toastId = toast.loading("Saving view");
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = {
      company_id,
      loginEmail,
      code,
      oldViewName: oldViewName,
      viewName: viewName,
      viewDescription: viewDescription,
      columnsInfo: [columnsInfo],
      assignedProjects: assignedProjects,
    };

    try {
      const res = await CompanyAdminServices.updateProcurementLogsViews(data);

      if (viewSaveFlag) {
        setCreateFlag(false);
        setEditFlag(false);
        readCompanySchedule();
      }

      viewSaveFlag = false;
      toast.success("View changes saved successfully", { id: toastId });

      if (!columnsChange && shouldRecalculate) {
        setShouldRecalculate(false);
        // First, call webhooksUpdate and wait for it to finish
        await webhooksUpdate(projectsInfoArray, company_id, code, loginEmail);
        // Then, call updateProjectsData
        await updateProjectsData(
          projectsInfoArray,
          company_id,
          code,
          loginEmail
        );
      }
    } catch (err) {
      toast.error("Something went wrong, please try again.", { id: toastId });
      console.log(err);
    }
  };

  const toggleAllVisibility = (show) => {
    setColumnsInfo((prev) => {
      const newColumnsInfo = { ...prev };
      Object.keys(newColumnsInfo).forEach((key) => {
        if (
          ![
            "entryID",
            "entryOrigin",
            "specSection",
            "specTitle",
            "specNumber",
            "specRevision",
            // "projectedDeliveryDate",
          ].includes(key) &&
          newColumnsInfo[key].usedStatus !== "unused"
        ) {
          newColumnsInfo[key] = {
            ...newColumnsInfo[key],
            hidden: show ? "false" : "true",
          };
        }
      });
      setSaveConfigurationFlag(true);
      return newColumnsInfo;
    });
  };

  const handlePreviewProjectsChange = (value) => {
    getSampleProcurementLogsViews(value);
  };

  let options = Object.entries(projectsDropDown).map(([key, value]) => ({
    label: value,
    value: key,
  }));

  // Assign to all projects
  const handleSelectAll = (e) => {
    const allValues = options.map((option) => option.value);

    // Set all values in the assigned projects
    setAssignedProjects(allValues);
    setDisableAssignProjectList(!disableAssignProjectList);
    setChangesMadeFlag(true);
  };

  const dataSource = dataSample.map((item, index) => ({
    key: index.toString(),
    ...Object.keys(item).reduce((acc, key) => {
      if (columnsInfo[key]?.hidden === "false") {
        acc[key] = item[key];
      }
      return acc;
    }, {}),
  }));

  const columns = Object.keys(columnsInfo)
    .filter((key) => columnsInfo[key].hidden === "false")
    .sort((a, b) => columnsInfo[a].index - columnsInfo[b].index)
    .map((key) => ({
      title: columnsInfo[key].label,
      dataIndex: key,
      key: key,
      align: "center",
      onCell: () => {
        return {
          style: {
            whiteSpace: "nowrap",
          },
        };
      },
    }));

  useEffect(() => {
    if (options.length > 0 && !initialSetupDone) {
      handlePreviewProjectsChange(options[0].value);
      setInitialSetupDone(true);
    }
  }, [options, initialSetupDone]);

  const formatFormulaForDisplay = (formula, key, columnsInfo) => {
    if (!formula || key === "projectedDeliveryDate")
      return "Koncurent Original Column";

    let formattedFormula = formula;

    // Replace each key in the formula with its corresponding label
    Object.keys(columnsInfo).forEach((key) => {
      const label = columnsInfo[key]?.label;
      if (label) {
        // Use regex to replace the key with the label, handling word boundaries
        const regex = new RegExp(`\\b${key}\\b`, "g");
        formattedFormula = formattedFormula.replace(regex, `${label}`);
      }
    });

    return formattedFormula;
  };

  const viewDetailsColumn = [
    {
      key: "sort",
      align: "center",
      width: 80,
      render: () => <DragHandle />,
    },
    {
      title: "Column Name",
      dataIndex: "label",
      key: "label",
      align: "left",
      render: (hidden, record) => {
        return (
          <Tooltip title="Edit">
            <div
              onClick={() => {
                setCreateColumnType(
                  record.source.startsWith("koncurentSchedule")
                    ? "Schedule Source"
                    : record.source === "koncurent"
                    ? record.formula !== ""
                      ? "Calculated Column"
                      : "Koncurent Hard coded"
                    : "Procore Source"
                );

                setColumnName(record.label);
                setColumnDescription(record.description);
                setColumnType(record.type);
                setColumnkey(record.key);
                setSource(record.source);
                setColumnFormula(record.formula);

                handleColumnFormula(record.formula, record.key, columnsInfo);
                setCreateNewColumnModalOpen(true);
              }}
            >
              <div className=" d-flex justify-content-between">
                <div>
                  <span>{record.label}</span>
                </div>
                <div>
                  {!record.key.includes("custom") && (
                    <Tooltip
                      title={formatFormulaForDisplay(
                        record.formula,
                        record.key,
                        columnsInfo
                      )}
                    >
                      <img
                        src={smallLogo}
                        alt="Small Logo"
                        style={{ width: "15px" }}
                      />
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: (
        <div className=" d-flex flex-row justify-content-between">
          <div className="w-100" style={{ marginLeft: "65px" }}>
            Visibility
          </div>
          <div className="w-25">
            <Tooltip title="Toggle All">
              <Switch
                checked={showAllColumns}
                onChange={(checked) => {
                  setShowAllColumns(checked);
                  toggleAllVisibility(checked);
                }}
              />
            </Tooltip>
          </div>
        </div>
      ),
      dataIndex: "Hidden",
      key: "Hidden",
      align: "center",
      render: (hidden, record) => (
        <Switch
          disabled={
            record.key === "specTitle" ||
            record.key === "specNumber" ||
            record.key === "specRevision"
            // record.key === "specType" ||
            // record.key === "submittalPrepTime" ||
            // record.key === "submittalIssued" ||
            // record.key === "approvalTime" ||
            // record.key === "submittalApprovalDue" ||
            // record.key === "submittalReturned" ||
            // record.key === "leadTime" ||
            // record.key === "dateRequiredOnSite"
            // record.key === "projectedDeliveryDate"
          }
          checked={record.hidden === "false"}
          onChange={() => handleVisibilityToggle(record.key)}
        />
      ),
    },
  ];

  const handleVisibilityToggle = (key) => {
    setColumnsInfo((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        hidden: prev[key].hidden === "false" ? "true" : "false",
      },
    }));

    setSaveConfigurationFlag(true);
  };

  const initialModalDataSource = Object.keys(columnsInfo)
    .filter(
      (key) =>
        key !== "entryID" &&
        key !== "specSection" &&
        key !== "specNumber" &&
        key !== "specTitle" &&
        key !== "specRevision" &&
        key !== "entryOrigin" &&
        columnsInfo[key].usedStatus !== "unused"
    )
    .sort((a, b) => columnsInfo[a].index - columnsInfo[b].index)
    .map((key) => ({
      key,
      ...columnsInfo[key],
    }));

  const [modalDataSource, setModalDataSource] = useState(
    initialModalDataSource
  );

  const handleModalOk = () => {
    setOriginalColumnsInfo(columnsInfo);
    setChangesMadeFlag(false);
    setModalOpen(false);
    viewSaveFlag = false;

    if (editFlag) {
      updateProcurementLogsViews();
      updateUndeleteableColumns();
    } else {
      setEditFlag(true);
      createProcurementLogsViews();
      updateUndeleteableColumns();
    }
    setSaveConfigurationFlag(false);
    setCloseConfigurationFlag(false);
  };

  const handleModalCancel = async () => {
    // setColumnsInfo(originalColumnsInfo);
    setModalOpen(false);

    if (!columnsChange && shouldRecalculate) {
      setShouldRecalculate(false);
      // Call webhooksUpdate first and wait for it to complete
      await webhooksUpdate(projectsInfoArray, company_id, code, loginEmail);
      // Then call updateProjectsData
      await updateProjectsData(projectsInfoArray, company_id, code, loginEmail);
    }

    // setSaveConfigurationFlag(false);
    // setCloseConfigurationFlag(false);
    setShouldRecalculate(false);
  };

  const handleCreateModalCancel = () => {
    setColumnName("");
    setColumnDescription("");
    setColumnType("");
    // setColumnkey("");
    // setSource("");
    // setColumnFormula([]);

    // setFormulaRows(originalFormulaRows);

    setCreateNewColumnModalOpen(false);
    // Using timeout to keep width of the modal until exit animation is done
    setTimeout(() => {
      setCreateColumnType("");
    }, 200);
  };

  const checkUnusedColumns = () => {
    let unusedCount = 0;
    let firstUnusedKey = "";

    Object.keys(columnsInfo).forEach((key) => {
      if (columnsInfo[key].usedStatus === "unused") {
        unusedCount += 1;

        if (!firstUnusedKey) {
          firstUnusedKey = key;
        }
      }
    });

    if (unusedCount > 12) {
      // Allowing 10 custom columns limit
      setCreateColumnFlag(false);
      setRemainingColumns(unusedCount - 12);
    } else {
      setCreateColumnFlag(true);
      setRemainingColumns(unusedCount - 12);
    }

    setFirstUnusedColumn(firstUnusedKey);
  };

  const saveCreateColumn = (columnDetails) => {
    setCreateNewColumnModalOpen(false);
    setColumnsChange(true);

    setColumnsInfo((prevColumnsInfo) => {
      // Check if firstUnusedColumn exists in columnsInfo
      if (firstUnusedColumn in prevColumnsInfo) {
        // Hold the original index and hidden properties
        const { index, hidden } = prevColumnsInfo[firstUnusedColumn];

        return {
          ...prevColumnsInfo,
          [firstUnusedColumn]: {
            ...prevColumnsInfo[firstUnusedColumn],
            ...columnDetails,
            index,
          },
        };
      }
      return prevColumnsInfo;
    });

    viewSaveFlag = false;

    setColumnName("");
    setColumnDescription("");
    setColumnType("");
    setColumnkey("");
    setSource("");

    // Using timeout to keep width of the modal until exit animation is done
    setTimeout(() => {
      setCreateColumnType("");
    }, 200);
  };

  const saveUpdateColumn = (columnDetails, columnkey) => {
    setCreateNewColumnModalOpen(false);
    setColumnsChange(true);

    setColumnsInfo((prevColumnsInfo) => {
      // Check if columnkey exists in columnsInfo
      if (columnkey in prevColumnsInfo) {
        // Hold the original index and hidden properties
        const { index, hidden } = prevColumnsInfo[columnkey];

        return {
          ...prevColumnsInfo,
          [columnkey]: {
            index,
            hidden,
            ...prevColumnsInfo[columnkey],
            ...columnDetails,
          },
        };
      }
      return prevColumnsInfo;
    });

    setColumnName("");
    setColumnDescription("");
    setColumnType("");
    setColumnkey("");
    setSource("");

    // Using timeout to keep width of the modal until exit animation is done
    setTimeout(() => {
      setCreateColumnType("");
    }, 200);
  };

  const deleteColumn = (columnDetails, columnkey) => {
    setCreateNewColumnModalOpen(false);
    setColumnsChange(true);

    setColumnsInfo((prevColumnsInfo) => {
      // Check if columnkey exists in columnsInfo
      if (columnkey in prevColumnsInfo) {
        // Hold the original index and hidden properties
        const { index } = prevColumnsInfo[columnkey];

        return {
          ...prevColumnsInfo,
          [columnkey]: {
            ...prevColumnsInfo[columnkey],
            ...columnDetails,
            index,
          },
        };
      }
      return prevColumnsInfo;
    });

    setColumnName("");
    setColumnDescription("");
    setColumnType("");
    setColumnkey("");
    setSource("");

    // Using timeout to keep width of the modal until exit animation is done
    setTimeout(() => {
      setCreateColumnType("");
    }, 200);
  };

  useEffect(() => {
    if (editFlag) {
      const projectIds = selectedViewName.viewProjects.map(
        (project) => project.split("-")[0]
      );
      setAssignedProjects(projectIds);
      setViewsProjects(projectIds);
      setOldViewName(viewName);
    }
  }, [editFlag, selectedViewName]);

  const onDragEnd = ({ active, over }) => {
    // Check if 'over' is null or undefined, indicating a drop outside the table bug
    if (over) {
      if (active.id !== over.id) {
        setModalDataSource((prev) => {
          const activeIndex = prev.findIndex(
            (record) => record.key === active.id
          );
          const overIndex = prev.findIndex((record) => record.key === over.id);
          const updatedDataSource = arrayMove(prev, activeIndex, overIndex);

          const updatedColumnsInfo = { ...columnsInfo };

          // First, assign fixed indexes
          [
            "entryID",
            "specSection",
            "specTitle",
            "specNumber",
            "specRevision",
            "entryOrigin",
          ].forEach((key, idx) => {
            if (updatedColumnsInfo[key]) {
              updatedColumnsInfo[key] = {
                ...updatedColumnsInfo[key],
                index: idx.toString(),
              };
            }
          });

          let newIndex = 5;
          updatedDataSource.forEach((record) => {
            updatedColumnsInfo[record.key] = {
              ...updatedColumnsInfo[record.key],
              index: newIndex.toString(),
            };
            newIndex += 1;
          });

          setColumnsInfo(updatedColumnsInfo);
          return updatedDataSource;
        });
        setSaveConfigurationFlag(true);
      }
    }
  };

  useEffect(() => {
    const updatedModalDataSource = Object.keys(columnsInfo)
      .filter(
        (key) =>
          key !== "entryID" &&
          key !== "specSection" &&
          key !== "specNumber" &&
          key !== "specRevision" &&
          key !== "specTitle" &&
          key !== "entryOrigin" &&
          columnsInfo[key].usedStatus !== "unused"
      )
      .sort((a, b) => columnsInfo[a].index - columnsInfo[b].index)
      .map((key) => ({
        key,
        ...columnsInfo[key],
      }));

    checkUnusedColumns();

    if (columnsChange) {
      if (editFlag) {
        updateProcurementLogsViews();
        updateUndeleteableColumns();
      } else {
        setEditFlag(true);
        createProcurementLogsViews();
        updateUndeleteableColumns();
      }
      setColumnsChange(false);
      setCloseConfigurationFlag(true);
      // setShouldRecalculate(true);
    }

    setModalDataSource(updatedModalDataSource);
  }, [columnsInfo]);

  // Preparing the formula when editing a column
  const convertFormulaIntoRows = (formulaString) => {
    if (!formulaString) return [];

    // Split the formula on + or - while keeping the operators
    const parts = formulaString.split(/([+-])/);

    // First part is always the first column
    const rows = [{ operator: "", columnKey: parts[0].trim() }];

    // Process the remaining parts in pairs (operator and value)
    for (let i = 1; i < parts.length - 1; i += 2) {
      rows.push({
        operator: parts[i].trim(),
        columnKey: parts[i + 1].trim(),
      });
    }

    if (rows[rows.length - 1].columnKey !== "") {
      rows.push({
        operator: "+",
        columnKey: "",
      });
    }

    return rows;
  };

  const handleColumnFormula = (columnFormula, columnKey, columnsInfo) => {
    // Check if columnKey has sufficient length and columnFormula exists
    if (columnKey.length > 2 && columnFormula) {
      const parsedRows = convertFormulaIntoRows(columnFormula);
      setFormulaRows(parsedRows);
      setFormula(columnFormula);

      // Set the column type based on the first column in the formula
      if (parsedRows[0]?.columnKey && columnsInfo[parsedRows[0].columnKey]) {
        setColumnType(columnsInfo[parsedRows[0].columnKey].type);
      }
    }
  };

  const [formula, setFormula] = useState("");

  const totalFloatColumns = Object.keys(columnsInfo).filter(
    (key) => columnsInfo[key].source === "koncurentSchedule-Total_Float"
  );

  return (
    <>
      <form
        onSubmit={handleSubmit(
          editFlag ? updateProcurementLogsViews : createProcurementLogsViews
        )}
      >
        <div className="my-4 d-flex justify-content-between">
          <Text>{viewName || "Untitled"}</Text>

          <div className="">
            <Button
              type="ghost"
              onClick={() => {
                setViewName("");
                setViewDescription("");
                setCreateFlag(false);
                setEditFlag(false);
                setChangesMadeFlag(false);
              }}
            >
              Cancel
            </Button>
            {viewName.length < 1 ? (
              <Tooltip title="View Name is a required field">
                <Button type="primary" disabled>
                  Save
                </Button>
              </Tooltip>
            ) : (
              <Button
                type="primary"
                disabled={!isDirty && !changesMadeFlag}
                onClick={() => {
                  viewSaveFlag = true;

                  editFlag
                    ? updateProcurementLogsViews()
                    : createProcurementLogsViews();
                }}
              >
                Save
              </Button>
            )}
          </div>
        </div>
        <div className="my-4 d-flex flex-column justify-content-between">
          <Text className={`${styles.title} mb-2`} dontWrap={false}>
            Information
          </Text>

          <div className="d-flex flex-column flex-lg-row justify-content-between">
            <div className="d-flex gap-4">
              <div className="mb-3">
                <label>
                  View Name <span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="viewName"
                  control={control}
                  render={({ field }) => (
                    <Input
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        setViewName(e.target.value);
                      }}
                      showCount
                      maxLength={30}
                      placeholder="Untitled"
                    />
                  )}
                />
              </div>
              <div className="mb-3">
                <label>View Description</label>
                <Controller
                  name="viewDescription"
                  control={control}
                  render={({ field }) => (
                    <Input
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                        setViewDescription(e.target.value);
                      }}
                      showCount
                      maxLength={100}
                      placeholder="Type a description here"
                    />
                  )}
                />
              </div>
            </div>
            <div className="w-25">
              <div className="d-flex gap-1">
                <div className="w-auto d-flex">
                  <Checkbox onChange={handleSelectAll} className="mb-2">
                    Assign to all projects
                  </Checkbox>
                </div>
              </div>

              <div className="">
                <label className="mb-1">Select Projects</label>
                <Controller
                  name="assignedProjects"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      mode="multiple"
                      allowClear
                      maxTagCount={2}
                      showSearch
                      disabled={disableAssignProjectList}
                      value={assignedProjects}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{
                        width: "100%",
                      }}
                      placeholder="0 projects selected"
                      onChange={(value) => {
                        field.onChange(value);
                        setAssignedProjects(value);
                      }}
                      options={options}
                    />
                  )}
                />
              </div>
            </div>
          </div>

          <hr className=" w-100" />
          <div className="d-flex flex-column flex-lg-row justify-content-between">
            <div className="d-flex gap-4">
              <div className="mb-3">
                <Text className={`${styles.title} mb-2`} dontWrap={false}>
                  Column Configuration
                </Text>
                {viewName.length < 1 ? (
                  <Tooltip title={"Please name the view to configure columns"}>
                    <Button
                      type="primary"
                      disabled={viewName.length < 1}
                      onClick={() => {
                        setModalOpen(true);
                      }}
                    >
                      Configure Columns
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    type="primary"
                    disabled={viewName.length < 1}
                    onClick={() => {
                      setModalOpen(true);
                    }}
                  >
                    Configure Columns
                  </Button>
                )}
              </div>
            </div>
            <div className="w-25">
              <div className="">
                <label>Preview with Project</label>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  style={{
                    width: "100%",
                  }}
                  placeholder="Select a project"
                  onChange={handlePreviewProjectsChange}
                  defaultValue={
                    options.length > 0 ? options[0].value : undefined
                  }
                  options={options}
                />
              </div>
            </div>
          </div>
          <div className=" w-100 m-x-3 overflow-scroll">
            <Table
              style={{
                maxHeight: 500,
              }}
              scroll={{ x: "max-content" }}
              bordered
              dataSource={dataSource}
              columns={columns}
              loading={isLoading ? { indicator: <LoadingComponent /> } : false}
              pagination={false}
            />
          </div>
        </div>

        <Modal
          // title="Configure Columns"
          centered
          open={modalOpen}
          onOk={
            !saveConfigurationFlag && closeConfigurationFlag
              ? handleModalCancel
              : handleModalOk
          }
          okButtonProps={{
            disabled: !saveConfigurationFlag && !closeConfigurationFlag,
          }}
          onCancel={handleModalCancel}
          okText="Save"
          width={900}
        >
          <div className=" d-flex justify-content-between my-4">
            <h5>Configure Columns</h5>
            <div className=" d-flex gap-3 align-items-center">
              <strong>
                Remaining unused columns:{" "}
                {remainingColumns < 0 ? 0 : remainingColumns}
              </strong>
              <Button
                type="primary"
                disabled={createColumnFlag}
                onClick={() => {
                  setCreateNewColumnModalOpen(true);
                  setColumnName("");
                  setColumnDescription("");
                  setColumnType("");
                  setColumnkey("");
                  setSource("");
                  setColumnFormula("");
                  setFormulaRows([]);
                }}
              >
                Create New Column
              </Button>
            </div>
          </div>
          <div className=" d-flex">
            <div className=" w-100 ">
              <DndContext
                modifiers={[restrictToVerticalAxis]}
                onDragEnd={onDragEnd}
              >
                <SortableContext
                  items={modalDataSource.map((item) => item.key)}
                  strategy={verticalListSortingStrategy}
                >
                  <Table
                    style={{ maxHeight: 700 }}
                    scroll={{ y: 550 }}
                    bordered
                    dataSource={modalDataSource}
                    columns={viewDetailsColumn}
                    components={{
                      body: {
                        row: SortableRow,
                      },
                    }}
                    pagination={false}
                  />
                </SortableContext>
              </DndContext>
            </div>
          </div>
        </Modal>
        <Modal
          centered
          open={createNewColumnModalOpen}
          onCancel={handleCreateModalCancel}
          footer={null}
          width={createColumnType ? 500 : 900}
        >
          <div className=" d-flex align-items-center mb-2">
            <h5 className="">
              {createColumnType === ""
                ? "Choose Column Type"
                : createColumnType === "Koncurent Hard coded"
                ? "User-Generated Input"
                : createColumnType === "Calculated Column"
                ? "Calculated"
                : createColumnType}
            </h5>
          </div>
          {createColumnType === "" ? (
            <div className="d-flex justify-content-between align-items-center gap-2">
              <Button
                size="large"
                className="w-100 d-flex flex-column justify-content-center align-items-center"
                style={{ height: "200px" }}
                onClick={() => {
                  setCreateColumnType("Koncurent Hard coded");
                }}
              >
                <h5>User-Generated Input</h5>
              </Button>

              <Button
                size="large"
                className="w-100 d-flex flex-column justify-content-center align-items-center"
                style={{ height: "200px" }}
                onClick={() => {
                  setCreateColumnType("Procore Source");
                }}
              >
                <div>
                  <h5>Procore Source</h5>
                </div>
              </Button>
              <Button
                size="large"
                className="w-100 d-flex flex-column justify-content-center align-items-center"
                style={{ height: "200px" }}
                onClick={() => {
                  setCreateColumnType("Calculated Column");
                }}
              >
                <div>
                  <h5>Calculated</h5>
                </div>
              </Button>
              <Tooltip
                title={
                  totalFloatColumns && totalFloatColumns.length > 0
                    ? "Only one Total Float column is allowed."
                    : ""
                }
              >
                <Button
                  size="large"
                  className="w-100 d-flex flex-column justify-content-center align-items-center"
                  style={{ height: "200px" }}
                  disabled={totalFloatColumns && totalFloatColumns?.length > 0}
                  onClick={() => {
                    setCreateColumnType("Schedule Source");
                  }}
                >
                  <div>
                    <h5>Schedule Source</h5>
                  </div>
                </Button>
              </Tooltip>
            </div>
          ) : (
            <CreateColumn
              createColumnType={createColumnType}
              saveCreateColumn={saveCreateColumn}
              saveUpdateColumn={saveUpdateColumn}
              deleteColumn={deleteColumn}
              columnName={columnName}
              setColumnName={setColumnName}
              columnDescription={columnDescription}
              setColumnDescription={setColumnDescription}
              columnType={columnType}
              setColumnType={setColumnType}
              columnkey={columnkey}
              procoreColumnsInfo={procoreColumnsInfo}
              scheduleColumnsInfo={scheduleColumnsInfo}
              undeletableColumns={undeletableColumns}
              source={source}
              setSource={setSource}
              columnsInfo={columnsInfo}
              columnFormula={columnFormula}
              setColumnFormula={setColumnFormula}
              formulaRows={formulaRows}
              setFormulaRows={setFormulaRows}
              createColumnFlag={createColumnFlag}
              formula={formula}
              setFormula={setFormula}
              setShouldRecalculate={setShouldRecalculate}
            />
          )}
        </Modal>
      </form>
    </>
  );
}
